<template>
  <div class="billing-admin-only" data-test="billing-admin-only">
    <!-- Same eyebrow / display title / lede block as the real Billing tab (BillingTab.vue), so the tab looks like part of the page. -->
    <div class="ma-tabhead">
      <div class="ma-tabhead__eyebrow">Billing</div>
      <h3 class="ma-tabhead__title">Billing is for Admins</h3>
      <p class="ma-tabhead__lede">
        Your practice&rsquo;s plan, payment method and invoices.
      </p>
    </div>

    <b-card class="bao-card">
      <p class="bao-text mb-0">
        <i class="la la-lock mr-2"></i>
        Only your practice&rsquo;s Admins can see billing. If you need something from it &mdash; an invoice, for example &mdash;
        please ask an Admin at your practice.
      </p>
    </b-card>
  </div>
</template>

<script>
/**
 * Shown in My Account -> Billing to everyone who is NOT an Admin / Super Admin (Saumil, 2026-10-14: "show the billing tab to
 * everybody ... when they click on it, show the fact that only admin gets access"). Purely presentational: it makes no API
 * call and reads no store, so a non-admin still never touches the billing endpoints (the server would 403 them anyway).
 * The real tab is BillingTab.vue; MyAccount.vue chooses between the two with isAdminOrAbove.
 */
export default {
  name: 'BillingAdminOnly',
};
</script>

<style lang="scss" scoped>
@import './PatientPayments/tokens';

.billing-admin-only { max-width: 960px; }

.ma-tabhead { margin-bottom: 20px; }
.ma-tabhead__eyebrow {
  font-size: 11px; font-weight: 700; letter-spacing: 0.12em; text-transform: uppercase;
  color: $pp-brand; margin-bottom: 8px;
}
.ma-tabhead__title {
  margin: 0; font-family: $pp-font-display; font-weight: 800; font-size: 24px;
  letter-spacing: -0.03em; line-height: 1.05; color: $pp-text;
}
.ma-tabhead__lede { margin: 8px 0 0; font-size: 14px; line-height: 1.5; color: $pp-text-muted; max-width: 660px; }

.bao-card { background: $pp-surface; border: 1px solid $pp-border; border-radius: $pp-radius; box-shadow: $pp-shadow; }
.bao-text { color: $pp-text-strong; line-height: 1.5; }
.bao-text .la { color: $pp-brand; }
</style>
